import { fetchWrapper } from '../utils';

const baseUrl = process.env.REACT_APP_BASE_API + 'auth';

export async function login(form) {
  const url = `${baseUrl}/login`;
  return await fetchWrapper.post(url, form);
}

export async function register(form) {
  const url = `${baseUrl}/register`;
  return await fetchWrapper.post(url, form);
}

export async function destroyUser(userId) {
  const url = `${baseUrl}/destroy`;
  return await fetchWrapper.post(url, { user_id: userId });
}

export async function checkUser(form) {
  const url = `${baseUrl}/check-user`;
  return await fetchWrapper.post(url, form);
}

export async function recover(form) {
  const url = `${baseUrl}/recover`;
  return await fetchWrapper.post(url, form);
}

export async function resetPassword(form) {
  const url = `${baseUrl}/reset`;
  return await fetchWrapper.post(url, form);
}

export async function logout() {
  removeSession();
}

export function removeSession() {
  window.location.replace(`${process.env.REACT_APP_BASENAME}/`);
}

export async function getProfile() {
  return await fetchWrapper.get(`${baseUrl}/get/profile`);
}

export async function getSelects() {
  return await fetchWrapper.post(`${baseUrl}/getselects`);
}

export async function getStates(form) {
  const url = `${baseUrl}/getstates`;
  return await fetchWrapper.post(url, form);
}

export async function getMunicipalities(form) {
  const url = `${baseUrl}/getmunicipalities`;
  return await fetchWrapper.post(url, form);
}